
export default {
  name: "MainFooter",
};
